
export default {
  name: "MainFooter",
};
